import clsx from "clsx"
import { FC, memo, useState } from "react"
import { CheckSolidIcon } from "./CheckSolidIcon"
import "./style.sass"

const TwoFactorComponent: FC = () => {
  // const { loading } = useSetupOTP(totp_enabled)
  const [method] = useState<"authentication" | "sms">("authentication")

  const isSmsMethod = method === "sms"

  return (
    <div className="two-factor">
      <span className="text-1">
        This security feature ensures exclusive access to your account, even if your password is compromised or disclosed.
      </span>

      <span className="text-2">Select authentication method that you prefer:</span>

      <div className="buttons-container">
        <div className={clsx("auth-button", { active: !isSmsMethod })}>Authentication</div>
        <div className={clsx("auth-button", { active: isSmsMethod })}>SMS</div>
      </div>

      <div className="success-container">
        <div className="icon-container">
          <CheckSolidIcon />
        </div>

        <span className="success-text">Success: Two-Factor Authentication on login has been configured correctly.</span>
      </div>

      <span className="text-4">
        When you log in, you will need to enter an authentication code generated by an app on your phone in addition to your username and password.
      </span>
    </div>
  )
}

export const TwoFactor = memo(TwoFactorComponent)
